module.exports = __webpack_public_path__ + "static/media/CTLI_13-315w.a38c09d9.webp";